import { twMerge } from 'tailwind-merge';

export function BorderBox(props: React.ComponentProps<'div'>) {
  return (
    <div
      {...props}
      className={twMerge(
        'xxs:py-2 xxs:px-3 xxs:mb-4 dark:text-black-50 xxs:border-black-100 dark:border-dex-black-700 xxs:border-solid xxs:border xxs:rounded-md overflow-hidden',
        props.className
      )}
    />
  );
}

export function BorderBoxLabel(props: React.ComponentProps<'div'>) {
  return <div className="xxs:mb-2 dark:text-black-50" {...props} />;
}
